<app-dialog-header label="Configuración alarmas" i18n-label></app-dialog-header>

<p style="margin-top: 1vh;">Cuando se genere una alarma, se enviará un correo a las siguientes direcciones:</p>

<app-form-text-area [(value)]="this.emails" label="Introduzca los emails separados por comas"></app-form-text-area>

<button style="float:right" type="button" class="btn btn-primary" (click)="saveChanges()">Guardar cambios</button>
